{
	"transactionCardHeader": "Validera en transaktion",
	"transactionCardDescriptionBold": "Vill du validera en transaktion för valfritt projekt?",
	"transactionCardDescriptionRegular": "Om du har ett transaktionsnummer till hands kan du ange det här och validera transaktionen.",
	"showTransactionButton": "Visa transaktion",
	"transactionLabel": "Transaktionsnummer",
	"errors": {
		"transactionIdRequired": "Transaktionsnummer krävs.",
		"transactionNotFound": "Transaktionen hittades inte.",
		"transactionIdInvalid": "Ogiltigt transaktionsnummer."
	}
}
